import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentDashboardRoutingModule } from './student-dashboard-routing.module';
import { StudentDashComponent } from './student-dash/student-dash.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularResizedEventModule } from 'angular-resize-event';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ChartistModule } from 'ng-chartist';
import { StudentEditComponent } from './student-edit/student-edit.component';
import { StudentProfileComponent } from './student-profile/student-profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NewDashboardComponent } from './new-dashboard/new-dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { StudentNewDashboardComponent } from './student-new-dashboard/student-new-dashboard.component';
import { LearnRoutingModule } from '../learn/learn-routing.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    StudentDashComponent,
    StudentEditComponent,
    StudentProfileComponent,
    NewDashboardComponent,
    StudentNewDashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StudentDashboardRoutingModule,
    ChartistModule,
    NgbModule,
    MatchHeightModule,
    NgApexchartsModule,
    NgxChartsModule,
    AngularResizedEventModule,
    NgSelectModule,
    PipeModule,
RouterModule,
        LearnRoutingModule,
      
        NgxSpinnerModule,
        NgxDatatableModule, 
       
  ]
})
export class StudentDashboardModule { }
